import './main.less';
import './item.less';
import React from 'react';
import PropTypes from 'prop-types';

import CommentForm from '../forms/comment/main';

const Notes = props => {
	const { notes, showMoreNotes, intl, removeNote } = props;
	return (
		<div className="timeline-container">
			<CommentForm {...props} isNote={true}/>
			{notes && notes.rows && notes.rows.length
				? notes.rows.map((item, i) =>
					<Item
						key={i}
						item={item}
						intl={intl}
						removeNote={removeNote}
					>
						{item && item.comment}
					</Item>)
				: null}
			<div className="table-container__navigation">
				{ notes  && notes.rows && notes.rows.length < notes.total &&
					<button className="ui-btn ui-btn-secondary" onClick={() => showMoreNotes()}>
						{intl('Show more')}
					</button>}
			</div>
		</div>
	);
};

const Item = props => (
	<div
		className={'note-item note-item-border'}
		key={1}
	>
		<div className="timeline-item-head note-item-head">
			<span className="text">
				<span>
					<span className="black">{props.item.email} {props.intl('added note: ')}</span>
					{props.children}
				</span>
				<span
					className="action_delete--button"
					onClick={() => props.removeNote(props.item.metadata && props.item.metadata.id)}
				/>
			</span>
			<span className="date">{props.item.date}</span>
		</div>
	</div>
);

Notes.propTypes = {
	logs: PropTypes.object,
	showMoreLogs: PropTypes.func,
	intl: PropTypes.func
};

export default Notes;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/notes/main.js